import styled from '@emotion/styled';
import { Button } from 'src/components-dummy';

export const ButtonStyled = styled(Button)`
  padding-left: 32px;
  padding-right: 32px;
`;
